import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	blockedLozengeNonFinal: {
		id: 'periscope.suggestions.blocking-issue.blocked-issue.blocked-lozenge-non-final',
		defaultMessage: 'Blocked',
		description: 'This is the text on the lozenge that indicates that the issue is blocked.',
	},
});
